<template>
    <video :key="src" ref="video" class="ae-banner__preview-video" muted>
        <source :src="src" type="video/mp4" />
    </video>
</template>

<script lang="ts" setup>
import { onMounted, useTemplateRef } from "vue";

const { src } = defineProps<{ src: string }>();

const emit = defineEmits<{
    (e: "videoLoaded", arg1: number): void;
    (e: "updateTime", arg1: number): void;
}>();

defineExpose({ play, pause, seek });

const video = useTemplateRef<HTMLVideoElement | null>("video");

onMounted(() => {
    video.value?.addEventListener("loadeddata", () => {
        if (!video.value) {
            return;
        }

        emit("videoLoaded", video.value.duration);
    });

    video.value?.addEventListener("timeupdate", () => {
        if (!video.value) {
            return;
        }

        emit("updateTime", video.value.currentTime);
    });
});

function seek(time: number) {
    if (!video.value) {
        return;
    }

    video.value.currentTime = time;
}

function play() {
    if (!video.value) {
        return;
    }

    video.value.play();
}

function pause() {
    if (!video.value) {
        return;
    }

    video.value.pause();
}
</script>

<style>
.ae-banner__preview-video {
    width: 100%;
}
</style>
